import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import messages from './messages';
import './styles.scss';

const offerPrice = props => {
  const { price, unit } = props;

  return (
    <div id="OfferPrice">
      <div className="price">
         <span>
           <FormattedMessage {...messages.description} />
         </span>
        {parseInt(price).toLocaleString('it') + unit}
        <span>
          / <FormattedMessage {...messages.price} />
        </span>
      </div>
      {
        false &&  <div className="price-description">
          <FormattedMessage {...messages.details} />
        </div>
      }
    </div>
  );
};

offerPrice.defaultProps = {
  unit: '€',
};

offerPrice.propTypes = {
  price: PropTypes.number.isRequired,
  unit: PropTypes.string,
};

export default offerPrice;
